import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Spinner } from '@app/components/Spinner/Spinner';

const Button = ({
	linkRef,
	linkTarget,
	label,
	type,
	size,
	simple,
	iconPos,
	icon,
	disabled,
	loading,
	spinnerSize,
	styleClass,
	onClick,
	ariaLabel,
	// children,
}) => {
	const ButtonWrap = linkRef ? 'a' : 'button';
	const classes = classnames(
		'ui-button',
		'ui-component',
		{
			'ui-button-icon-only': icon && !label,
			[styleClass]: !!styleClass,
			'ui-button-link': !!linkRef,
			'ui-state-disabled': disabled,
		},
		...(simple
			? ['ui-button-simple']
			: [`ui-button-${type}`, `ui-button-${size}`]),
	);

	const props = linkRef
		? {
				href: linkRef,
				target: linkTarget,
		  }
		: {};

	return (
		<ButtonWrap
			{...props}
			className={classes}
			disabled={disabled}
			onClick={onClick}
			aria-label={ariaLabel}
		>
			{loading && !simple ? (
				<Spinner
					loading
					size={spinnerSize || (size === 'tiny' ? 'tiny' : 'small')}
					text=""
					color={type !== 'secondary' ? 'white' : 'black'}
				/>
			) : (
				<Fragment>
					{iconPos === 'left' && icon}
					{label && <span>{label}</span>}
					{iconPos === 'right' && icon}
				</Fragment>
			)}
		</ButtonWrap>
	);
};

Button.defaultProps = {
	type: 'primary',
	size: 'medium',
	iconPos: 'left',
};

Button.propTypes = {
	linkRef: PropTypes.string,
	linkTarget: PropTypes.string,
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	type: PropTypes.oneOf(['primary', 'secondary', 'warning', 'shadow']),
	size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large']),
	simple: PropTypes.bool,
	iconPos: PropTypes.oneOf(['left', 'right']),
	icon: PropTypes.element,
	disabled: PropTypes.bool,
	loading: PropTypes.bool,
	onClick: PropTypes.func,
	children: PropTypes.any,
	spinnerSize: PropTypes.string,
	styleClass: PropTypes.string,
	ariaLabel: PropTypes.string,
};

export default Button;
